<template>
  <svg fill="none" width="12" height="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      d="M1.125 6.05 4.075 9l6.05-6"
      stroke="currentColor"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
